/**
 * Mock data for workshops in the SCAD system with diverse topics
 * Centralizes workshop data for the WorkshopHub component
 */

export const diverseWorkshops = [
  // Live Now Workshops (4)
  {
    id: 'WS-2025-001',
    title: 'Advanced Digital Marketing Analytics',
    category: 'Marketing',
    description: 'Master digital marketing analytics tools and metrics. Learn to create data-driven marketing strategies and measure campaign ROI through practical examples.',
    date: '2025-05-11',
    time: '10:00 - 12:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Zoom',
    type: 'live',
    price: 45,
    thumbnailUrl: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 40,
    currentAttendees: 35,
    presenter: 'Sarah Johnson',
    presenterImage: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Digital Marketing Director with 10+ years experience in leading global campaigns.',
    prerequisites: ['Basic marketing knowledge', 'Familiarity with Google Analytics'],
    materials: ['Analytics Dashboard Template', 'ROI Calculator', 'Case Studies'],
    rating: 4.8,
    reviews: [
      { name: 'Omar Hassan', rating: 5, comment: 'Incredibly insightful session!' },
      { name: 'Laila Ahmed', rating: 4.5, comment: 'Great practical examples and tips.' }
    ]
  },
  {
    id: 'WS-2025-013',
    title: 'Data Visualization with D3.js',
    category: 'Computer Science',
    description: 'Learn to create stunning interactive data visualizations using D3.js. Master SVG basics, data binding, transitions, and responsive design techniques.',
    date: '2025-05-11',
    time: '11:00 - 13:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Microsoft Teams',
    type: 'live',
    price: 50,
    thumbnailUrl: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 35,
    currentAttendees: 28,
    presenter: 'Dr. Emily Zhang',
    presenterImage: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Senior Data Visualization Engineer at Google, PhD in Computer Graphics',
    prerequisites: ['JavaScript fundamentals', 'Basic understanding of SVG', 'HTML/CSS knowledge'],
    materials: ['Example Code', 'Datasets', 'Project Templates'],
    rating: 4.9,
    reviews: [
      { name: 'Fatima Khan', rating: 5, comment: 'Amazing workshop on D3.js visualization!' },
      { name: 'Ahmad Rashid', rating: 4.8, comment: 'Very practical and hands-on learning experience.' }
    ]
  },
  {
    id: 'WS-2025-014',
    title: 'UX Research Methods',
    category: 'Design',
    description: 'Deep dive into user experience research methodologies. Learn how to conduct user interviews, usability testing, and analyze research data effectively.',
    date: '2025-05-11',
    time: '12:00 - 14:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Zoom',
    type: 'live',
    price: 45,
    thumbnailUrl: 'https://images.unsplash.com/photo-1553484771-047a44eee27a?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 40,
    currentAttendees: 32,
    presenter: 'Sophie Anderson',
    presenterImage: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Lead UX Researcher at Microsoft, 8+ years of industry experience',
    prerequisites: ['Basic understanding of UX design', 'Interest in user research'],
    materials: ['Research Templates', 'Interview Guides', 'Analysis Tools'],
    rating: 4.8,
    reviews: [
      { name: 'Sara Ali', rating: 5, comment: 'Excellent insights into UX research methods!' },
      { name: 'Mohammed Hassan', rating: 4.6, comment: 'Very comprehensive coverage of research techniques.' }
    ]
  },
  {
    id: 'WS-2025-002',
    title: 'AI in Financial Trading',
    category: 'Finance',
    description: 'Explore how artificial intelligence is revolutionizing financial trading. Learn about algorithmic trading, machine learning in market prediction, and risk management.',
    date: '2025-05-11',
    time: '13:00 - 15:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Microsoft Teams',
    type: 'live',
    price: 60,
    thumbnailUrl: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 30,
    currentAttendees: 28,
    presenter: 'Dr. Michael Chen',
    presenterImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Senior Quantitative Analyst with PhD in Financial Engineering',
    prerequisites: ['Basic understanding of finance', 'Python basics'],
    materials: ['Trading Algorithms', 'Market Analysis Tools', 'Case Studies'],
    rating: 4.9,
    reviews: [
      { name: 'Ahmed Samir', rating: 5, comment: 'Excellent insights into AI applications in finance' }
    ]
  },
  {
    id: 'WS-2025-003',
    title: 'Advanced Sports Performance Analytics',
    category: 'Sports',
    description: 'Deep dive into sports analytics, performance metrics, and data-driven decision making in professional sports. Learn to use modern tools for player performance analysis.',
    date: '2025-05-11',
    time: '14:00 - 16:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Zoom',
    type: 'live',
    price: 50,
    thumbnailUrl: 'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 35,
    currentAttendees: 30,
    presenter: 'James Martinez',
    presenterImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Former Pro Athlete and Sports Analytics Expert',
    prerequisites: ['Basic statistics knowledge', 'Interest in sports analytics'],
    materials: ['Performance Metrics Guide', 'Analytics Software Tutorial', 'Case Studies'],
    rating: 4.7,
    reviews: [
      { name: 'Mohamed Ali', rating: 5, comment: 'Revolutionary approach to sports analysis' }
    ]
  },
  {
    id: 'WS-2025-004',
    title: 'Machine Learning in Architecture',
    category: 'Artificial Intelligence in Architecture',
    description: 'Explore the intersection of ML and architectural design. Learn how AI is transforming building design, space optimization, and sustainable architecture.',
    date: '2025-05-11',
    time: '15:00 - 17:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Zoom',
    type: 'live',
    price: 55,
    thumbnailUrl: 'https://images.unsplash.com/photo-1525434280693-3e9c45fd9959?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 40,
    currentAttendees: 35,
    presenter: 'Dr. Elena Rodriguez',
    presenterImage: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'AI Architect, Professor at MIT',
    prerequisites: ['Basic architectural knowledge', 'Interest in AI'],
    materials: ['ML Tools Guide', 'Case Studies', 'Practice Datasets'],
    rating: 4.9,
    reviews: [
      { name: 'Nour Hadi', rating: 5, comment: 'Fascinating integration of AI and architecture' }
    ]
  },

  // Pre-recorded Workshops (4)
  {
    id: 'WS-2025-005',
    title: 'Full-Stack Development with MERN',
    category: 'Computer Science',
    description: 'Comprehensive guide to building modern web applications using MongoDB, Express.js, React, and Node.js. Learn through practical projects.',
    date: '2025-05-10',
    time: 'Available 24/7',
    duration: '8 hours',
    location: 'Online',
    platform: 'Learning Portal',
    type: 'pre-recorded',
    price: 75,
    thumbnailUrl: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 100,
    currentAttendees: 45,
    presenter: 'David Cooper',
    presenterImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Senior Software Engineer, Tech Author',
    prerequisites: ['JavaScript knowledge', 'Basic web development'],
    materials: ['Source Code', 'Project Files', 'Documentation'],
    rating: 4.8,
    reviews: [
      { name: 'Yasser Mahmoud', rating: 5, comment: 'Excellent course structure and content' }
    ]
  },
  {
    id: 'WS-2025-006',
    title: 'Investment Portfolio Management',
    category: 'Finance',
    description: 'Master the art of portfolio management, risk assessment, and investment strategies. Learn modern approaches to asset allocation.',
    date: '2025-05-09',
    time: 'Available 24/7',
    duration: '6 hours',
    location: 'Online',
    platform: 'Learning Portal',
    type: 'pre-recorded',
    price: 65,
    thumbnailUrl: 'https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 100,
    currentAttendees: 55,
    presenter: 'Jennifer Wong',
    presenterImage: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Portfolio Manager with 15 years experience',
    prerequisites: ['Basic financial knowledge', 'Understanding of markets'],
    materials: ['Investment Guide', 'Risk Assessment Tools', 'Case Studies'],
    rating: 4.7,
    reviews: [
      { name: 'Karim Saleh', rating: 5, comment: 'Very comprehensive coverage of portfolio management' }
    ]
  },
  {
    id: 'WS-2025-007',
    title: 'Sports Psychology and Performance',
    category: 'Sports',
    description: 'Understanding the mental aspects of athletic performance, motivation, and competitive psychology in sports.',
    date: '2025-05-08',
    time: 'Available 24/7',
    duration: '5 hours',
    location: 'Online',
    platform: 'Learning Portal',
    type: 'pre-recorded',
    price: 45,
    thumbnailUrl: 'https://images.unsplash.com/photo-1526676037777-05a232554f77?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 100,
    currentAttendees: 40,
    presenter: 'Dr. Sarah Thompson',
    presenterImage: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Sports Psychologist for Olympic Athletes',
    prerequisites: ['Interest in sports psychology', 'Basic psychology concepts'],
    materials: ['Mental Training Guide', 'Exercise Workbook', 'Case Studies'],
    rating: 4.6,
    reviews: [
      { name: 'Ali Hassan', rating: 5, comment: 'Invaluable insights for athletes' }
    ]
  },
  {
    id: 'WS-2025-008',
    title: 'Sustainable Architectural Design',
    category: 'Artificial Intelligence in Architecture',
    description: 'Learn about sustainable architecture principles, green building practices, and eco-friendly design solutions.',
    date: '2025-05-07',
    time: 'Available 24/7',
    duration: '7 hours',
    location: 'Online',
    platform: 'Learning Portal',
    type: 'pre-recorded',
    price: 70,
    thumbnailUrl: 'https://images.unsplash.com/photo-1481026469463-66327c86e544?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 100,
    currentAttendees: 65,
    presenter: 'Prof. Thomas Wright',
    presenterImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Sustainable Design Expert, LEED Certified Architect',
    prerequisites: ['Basic architectural knowledge', 'Interest in sustainability'],
    materials: ['Design Guidelines', 'Case Studies', 'Green Building Standards'],
    rating: 4.8,
    reviews: [
      { name: 'Noura Selim', rating: 5, comment: 'Excellent coverage of sustainable practices' }
    ]
  },

  // Upcoming Workshops (4)
  {
    id: 'WS-2025-009',
    title: 'Content Marketing Mastery',
    category: 'Marketing',
    description: 'Learn advanced content marketing strategies, SEO optimization, and audience engagement techniques for digital platforms.',
    date: '2025-05-20',
    time: '14:00 - 16:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Zoom',
    type: 'upcoming',
    price: 40,
    thumbnailUrl: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 45,
    currentAttendees: 20,
    presenter: 'Lisa Anderson',
    presenterImage: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Content Strategy Director at Leading Digital Agency',
    prerequisites: ['Basic marketing knowledge', 'Writing skills'],
    materials: ['Content Strategy Template', 'SEO Guide', 'Case Studies'],
    rating: 0,
    reviews: []
  },
  {
    id: 'WS-2025-010',
    title: 'Blockchain in Finance',
    category: 'Finance',
    description: 'Introduction to blockchain technology in financial services, cryptocurrency markets, and decentralized finance (DeFi).',
    date: '2025-05-25',
    time: '15:00 - 17:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Microsoft Teams',
    type: 'upcoming',
    price: 55,
    thumbnailUrl: 'https://images.unsplash.com/photo-1621761191319-c6fb62004040?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 35,
    currentAttendees: 15,
    presenter: 'Alex Martinez',
    presenterImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Blockchain Developer and FinTech Consultant',
    prerequisites: ['Basic finance knowledge', 'Interest in cryptocurrency'],
    materials: ['Blockchain Basics', 'DeFi Guide', 'Market Analysis Tools'],
    rating: 0,
    reviews: []
  },
  {
    id: 'WS-2025-011',
    title: 'High-Performance Training Methods',
    category: 'Sports',
    description: 'Advanced training methodologies for athletes, including periodization, recovery optimization, and performance tracking.',
    date: '2025-05-30',
    time: '16:00 - 18:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Zoom',
    type: 'upcoming',
    price: 45,
    thumbnailUrl: 'https://images.unsplash.com/photo-1517963879433-6ad2b056d712?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 40,
    currentAttendees: 10,
    presenter: 'Mark Johnson',
    presenterImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Elite Performance Coach, Former Olympic Trainer',
    prerequisites: ['Basic training knowledge', 'Sports background'],
    materials: ['Training Programs', 'Recovery Guidelines', 'Performance Metrics'],
    rating: 0,
    reviews: []
  },
  {
    id: 'WS-2025-012',
    title: 'Generative AI in Architecture',
    category: 'Artificial Intelligence in Architecture',
    description: 'Explore generative design and AI-powered tools for creating innovative architectural solutions and optimizing building performance.',
    date: '2025-06-05',
    time: '13:00 - 15:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Microsoft Teams',
    type: 'upcoming',
    price: 65,
    thumbnailUrl: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 30,
    currentAttendees: 5,
    presenter: 'Prof. Carlos Silva',
    presenterImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Leading expert in computational design and AI architecture',
    prerequisites: ['Basic architectural design', '3D modeling experience'],
    materials: ['Generative Design Tools', 'Case Studies', 'Project Templates'],
    rating: 0,
    reviews: []
  }
];

// Mock data for completed workshops
export const completedWorkshops = [
  {
    id: 'WS-2025-003',
    title: 'AI in Architectural Design',
    date: '2025-05-11',
    presenter: 'Prof. Elena Rodriguez',
    status: 'completed',
    certificate: 'CERT-2025-003',
    rating: 5,
    feedback: 'Excellent workshop! Really helped me understand AI applications in architecture.'
  }
];
